import {Field, useField} from "formik";
import {Switch} from "formik-mui";
import {Fragment} from "react";


export const ManagedSwitch = ({...props}) => {
    const [field] = useField(props);
    return(
        <Fragment>
            <Field
                {...field}
                {...props}
                component={Switch}
                type={"checkbox"}
                checked={field.value}
            />
        </Fragment>
    );
};